import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';
import LogService from '../services/LogService';
import axios from 'axios';

class OperationRepository {
  httpClientAdapter;
  lastmileApiUrl;
  logService;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_LASTMILE_API_URL');
    this.logService = Container.get(LogService);
  }
  async getOperations(page, rowsPerPage, filters) {
    try {
      let baseUrl = `${this.lastmileApiUrl}/operation?pageNum=${page}&pageSize=${rowsPerPage}`;
      let filtersArray = [];
      if (filters) {
        if (filters.createdFromDate) {
          filtersArray.push(`createdFromDate=${filters.createdFromDate}`);
        }
        if (filters.states) {
          for (const state of filters.states) {
            filtersArray.push(`state=${state}`);
          }
        } else {
          filtersArray.push(`state=NOTDONE&state=DONE&state=REJECTED&state=PARTIALLYDONE`);
        }
        if (filters.idRoute) {
          filtersArray.push(`idRoute=${filters.idRoute}`);
        }
        if (filters.vehicle) {
          filtersArray.push(`idVehicle=${filters.vehicle.id}`);
        }
        if (filters.includeImages) {
          filtersArray.push(`includeImages=${filters.includeImages}`);
        }
        if (filters.excludeDepot) {
          filtersArray.push(`excludeDepot=${filters.excludeDepot}`);
        }
        if (filters.includeLocation) {
          filtersArray.push(`includeLocation=${filters.includeLocation}`);
        }
      }
      const filterQuery = filtersArray.join('&');
      const url = baseUrl + (filterQuery.length ? `&${filterQuery}` : '');
      this.logService.sendInfo({
        component: 'operationRepository',
        message: 'getOperations solicitando la siguiente url al back ' + url,
      });
      const clientId = Container.get('clientId');
      const accessToken = Container.get('accessToken');
      console.log(url);
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        },
      };
      return await this.httpClientAdapter.get(url, config);
    } catch (e) {
      console.log(e);
      return {
        data: [],
        paginator: {
          totalRows: 0,
        },
      };
    }
  }
  async getStatusByPlanification(listOpUuid, planificationId) {
    const urlPlanification = `${this.lastmileApiUrl}/operation/byPlanification/${planificationId}`;
    try {
      this.logService.sendInfo({
        component: 'operationProcess',
        message: `getOperationsWithStatus voy a buscar las operaciones con la url ${urlPlanification}`,
      });
      const clientId = Container.get('clientId');
      const accessToken = Container.get('accessToken');
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await axios.post(urlPlanification, listOpUuid, config);
      const data = response.data.data;
      data.forEach((op) => {
        if (op.state === 'NEW') {
          op.state = 'NOTHANDLED';
        }
      });
      return data;
    } catch (e) {
      this.logService.sendError({
        component: 'operationProcess',
        message: `getOperationsWithStatus fallo ${e.message}`,
      });
      console.log(e);
      return [];
    }
  }
}

Container.set({ id: OperationRepository, type: OperationRepository });

export default OperationRepository;
